import { Link } from '@remix-run/react'
import { Button, ButtonProps } from 'antd'
import React from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'

const Wrapper = styled(Button)<{ $isActive: boolean }>`
  border-bottom: 2px solid transparent;

  ${props => {
    if (props.$isActive) {
      return `border-bottom-color: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};`
    }

    return ``
  }}
`

type Props = ButtonProps & { isActive: boolean; to?: string }

export const TabItem: React.FC<Props> = ({
  children,
  isActive,
  to,
  ...props
}) => {
  const propsBuilt: ButtonProps = {
    variant: 'text',
    color: 'default',
    ...props,
    style: { ...props.style },
  }

  if (to) {
    return (
      <Link to={to}>
        <Wrapper {...propsBuilt} $isActive={isActive}>
          {children}
        </Wrapper>
      </Link>
    )
  }

  return (
    <>
      <Wrapper {...propsBuilt} $isActive={isActive}>
        {children}
      </Wrapper>
    </>
  )
}
